import ApiService from '@/services/core/api.service'

const ActivityService = {
  async get (query) {
    return ApiService.get(`agent/activities?${query}`)
  },

  async post (payload) {
    return ApiService.post('agent/activities', payload)
  },

  async put (payload) {
    return ApiService.put(`agent/activities/${payload.id}`, payload)
  }
}

export default ActivityService
